import React from "react"
import PropTypes from "prop-types"
import ReactMarkdown from "react-markdown"

import { StyledWrapper } from "./MarkdownRenderer.styles"

const MarkdownRenderer = ({ content, customStyles }) => {
  return (
    <StyledWrapper customStyles={customStyles}>
      <ReactMarkdown source={content} />
    </StyledWrapper>
  )
}

MarkdownRenderer.propTypes = {
  content: PropTypes.string.isRequired,
  customStyles: PropTypes.any,
}

MarkdownRenderer.defaultProps = {
  customStyles: "",
}

export default MarkdownRenderer
